import React, { useEffect, useState } from 'react';

import { getReviews } from '../../../../api/reviews';
import {
	Card,
	CardBody,
	CardHeader,
} from '../../../../_metronic/_partials/controls';
import Table, { dateFormatter } from '../../../components/tables/table';
import { alertError } from '../../../../utils/logger';

const getData = (entries) =>
	entries.map((entry) => ({
		...entry,
		exercise: entry.exercise?.title || '---',
		user: entry.user?.fullName || entry.guest?._id || '---',
	}));

export function ReviewsByExercisePage() {
	const [data, setData] = useState([]);
	const [refresh, setRefresh] = useState(false);

	const columns = [
		{
			dataField: 'timestamp',
			text: 'Timestamp',
			formatter: dateFormatter,
			sort: true,
		},
		{ dataField: 'exercise', text: 'Exercise', sort: true },
		{ dataField: 'action', text: 'Acción', sort: true },
		{ dataField: 'user', text: 'User', sort: true },
	];

	useEffect(() => {
		getReviews('?by-exercise=true')
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data));
					setRefresh(false);
				}
			})
			.catch((error) =>
				alertError({
					error: error,
					customMessage: 'Could not get entries.',
				})
			);
	}, [refresh]);

	return (
		<Card>
			<CardHeader title={'Exercise Reviews'} />
			<CardBody>
				<Table data={data} columns={columns} />
			</CardBody>
		</Card>
	);
}
